import { z } from "zod";

const emailSchema = z
  .string()
  .min(1, "Email is required")
  .email("Please enter a valid email address");

const passwordSchema = z
  .string()
  .min(1, "Password is required")
  .min(8, "Password must be at least 8 characters long")
  .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
  .regex(/[a-z]/, "Password must contain at least one lowercase letter")
  .regex(/[0-9]/, "Password must contain at least one number");

const nameSchema = z
  .string()
  .min(1, "Name is required")
  .min(2, "Name must be at least 2 characters long")
  .max(255, "Name must be less than 255 characters");

const organizationNameSchema = z
  .string()
  .min(1, "Organization name is required")
  .min(2, "Organization name must be at least 2 characters long")
  .max(255, "Organization name must be less than 255 characters");

export const validateEmail = (email: string): string | undefined => {
  const result = emailSchema.safeParse(email);
  return result.success ? undefined : result.error.errors[0]?.message;
};

export const validatePassword = (password: string): string | undefined => {
  const result = passwordSchema.safeParse(password);
  return result.success ? undefined : result.error.errors[0]?.message;
};

export const validateName = (name: string): string | undefined => {
  const result = nameSchema.safeParse(name);
  return result.success ? undefined : result.error.errors[0]?.message;
};

export const validateOrganizationName = (name: string): string | undefined => {
  const result = organizationNameSchema.safeParse(name);
  return result.success ? undefined : result.error.errors[0]?.message;
};
